import { useTypedTranslate } from 'providers/i18n/hooks/useTypedTranslate';
import { SimpleForm, useNotify } from 'react-admin';
import { CancelButton, SaveButtonValidated } from 'shared/mui/Buttons';
import { CardActionsButtons } from 'shared/mui/Card';
import { EditPage } from 'shared/react-admin/Pages/EditPage/EditPage';

import { ReferralsForm } from './components/ReferralsFrom';

export const ReferralsEdit: React.FC = () => {
  const translate = useTypedTranslate();

  const notify = useNotify();

  function onError(error: any) {
    notify(error.message, { type: 'error' });
  }

  return (
    <EditPage
      listName={translate('app.referrals.title')}
      mutationMode="pessimistic"
      mutationOptions={{ onError }}
      title={translate('app.referrals.editTitle')}
    >
      <SimpleForm sx={{ '&.MuiCardContent-root': { padding: 0 } }} toolbar={false}>
        <ReferralsForm />
        <CardActionsButtons
          rightActionsSlot={[
            <CancelButton key="cancel-button" variant="outlined" />,
            <SaveButtonValidated key="save-button" />,
          ]}
          sx={{ marginTop: 'auto', padding: 0 }}
        />
      </SimpleForm>
    </EditPage>
  );
};
